import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/newsletters', label: 'Newsletter Library' },
    { path: '/quick-reads', label: 'Quick Reads' },
    { path: '/videos', label: 'Video Library' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => {
    if (path === '/newsletters') {
      return location.pathname === '/newsletters' || location.pathname.startsWith('/newsletter/');
    }
    if (path === '/quick-reads') {
      return location.pathname === '/quick-reads' || location.pathname.startsWith('/quick-read/');
    }
    if (path === '/videos') {
      return location.pathname === '/videos';
    }
    return location.pathname === path;
  };

  return (
    <header className="header-sticky sticky top-0 z-50 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-28 lg:h-32">
          {/* Logo with transparent background - enlarged and color adjusted */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_broker-library/artifacts/tgrnnxfl_e-removebg-preview.png" 
              alt="First Choice Business Brokers" 
              className="h-20 lg:h-24 w-auto logo-enhanced"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-smooth link-underline py-2 ${
                  isActive(link.path)
                    ? 'text-foreground'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden md:flex items-center">
            <Link
              to="/contact"
              className="btn-primary px-5 py-2.5 rounded-lg text-sm font-semibold"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-smooth"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-sm font-medium py-2 ${
                    isActive(link.path)
                      ? 'text-foreground'
                      : 'text-muted-foreground'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="btn-primary px-5 py-2.5 rounded-lg text-sm font-semibold text-center mt-2"
              >
                Get Started
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
